class ErrorFromArray {
	constructor(vueContext, error = []) {
		this.error = error;
		this.vueContext = vueContext;
	}
	showError = () => {
		let title = "";
		let text = "";
		const reasonMessage = this.error.map(({absolute_path, message}) => {
			return absolute_path[0].replaceAll("_", " ").toUpperCase() + ": " + this.validatorMessage(message);
		});
		title = this.vueContext.$t("ErrorTitle");
		text = `${this.vueContext.$t("DesignConfig.Property")} ${reasonMessage[0]}`;
		this.vueContext.$vs.notify({
			color: "danger",
			title,
			text,
			time: 8000,
			icon: "info",
		});
	};

	validatorMessage = (message = "") => {
		if (message.includes("is too short") && !message.includes("[]")) {
			return this.vueContext.$t("Setting.TooShortProperties") + ". " + this.vueContext.$t("Setting.ReviewValues");
		} else if (message.includes("[] is too short")) {
			return this.vueContext.$t("DesignConfig.SelectMinimumOneOption");
		} else if (message.includes("is not one of")) {
			return this.vueContext.$t("DesignConfig.SelectMinimumOneOption");
		} else if (message.includes("is not of type 'string'")) {
			return this.vueContext.$t("Setting.IsNotStringValid");
		} else if (message.includes("is greater than the maximum")) {
			return (
				this.vueContext.$t("Setting.IsGreaterThanMaximum") + ". " + this.vueContext.$t("Setting.ReviewValues")
			);
		} else if (message.includes("is less than the minimum")) {
			return this.vueContext.$t("Setting.IsLessThanMinimum") + ". " + this.vueContext.$t("Setting.ReviewValues");
		} else if (message.includes("is too long")) {
			return this.vueContext.$t("Setting.IsTooLong") + ". " + this.vueContext.$t("Setting.ReviewValues");
		} else {
			return this.vueContext.$t("Setting.ValidatorRequiredProperty");
		}
	};
}

export default ErrorFromArray;
